import "./AnnouncementRegion.less";
import { useAppSelector } from "app/hooks";

/**
 * Global announcement region that persists across component unmounts
 * This should be rendered once at the app level to ensure announcements
 * are not lost when components are reordered (Safari issue)
 */
export function GlobalAnnouncementRegion() {
    const message = useAppSelector(
        (state) => state.qualityForm.data.screenReaderAnnouncement
    );

    return (
        <div
            role="status"
            aria-live="polite"
            className="sr-only"
            data-testid="global-announcement-region"
        >
            {message}
        </div>
    );
}
